module.exports = __webpack_public_path__ + "img/37200.80f4e5ae.jpg";